import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { CartProvider } from "./context/CartContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import WhatsAppButton from "./components/WhatsAppButton";
import Home from "./pages/Home";
import { SpicesPage, TextilesPage, DecoPage, OilsPage } from "./pages/CategoryRoutes";
import ProductDetail from "./pages/ProductDetail";
import Story from "./pages/Story";
import Artisans from "./pages/Artisans";
import Contact from "./pages/Contact";
import Wishlist from "./pages/Wishlist";
import Saffron from "./pages/Saffron";

function App() {
  return (
    <LanguageProvider>
      <CartProvider>
        <BrowserRouter>
          <div className="App min-h-screen bg-[#FAF9F6] text-[#1A1A1A]">
            <Navbar />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/spices" element={<SpicesPage />} />
                <Route path="/textiles" element={<TextilesPage />} />
                <Route path="/deco" element={<DecoPage />} />
                <Route path="/oils" element={<OilsPage />} />
                <Route path="/saffron" element={<Saffron />} />
                <Route path="/product/:slug" element={<ProductDetail />} />
                <Route path="/story" element={<Story />} />
                <Route path="/artisans" element={<Artisans />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/wishlist" element={<Wishlist />} />
              </Routes>
            </main>
            <Footer />
            <CartDrawer />
            <WhatsAppButton />
          </div>
        </BrowserRouter>
      </CartProvider>
    </LanguageProvider>
  );
}

export default App;
